
  import { defineComponent, PropType } from 'vue';

  import { TFilter } from '@/common/components/redesigned/Filter/types/filter';
  import TableComponent from '@/common/components/redesigned/Table/TableComponent.vue';
  import {
    TSortParams,
    TTableColumnConfig,
    TTableEventConfigs,
  } from '@/common/components/redesigned/Table/types/tableTypes';
  import { TStorePaths } from '@/common/types/storePaths';

  import { TDashboardsTableItem } from '../../types/dashboards';

  export default defineComponent({
    name: 'EventsBaseTable',
    components: { TableComponent },
    props: {
      title: {
        type: String,
        default: '',
      },
      storePaths: {
        type: Object as PropType<TStorePaths>,
        required: true,
      },
      params: {
        type: Object as PropType<TFilter>,
        default: () => ({}),
      },
      columns: {
        type: Array as PropType<TTableColumnConfig<TDashboardsTableItem>[]>,
        required: true,
      },
      eventConfigs: {
        type: Array as PropType<TTableEventConfigs<TDashboardsTableItem>>,
        default: () => [],
      },
      emptyText: {
        type: String,
        default: 'Нет данных',
      },
      updateTrigger: {
        type: Number,
        default: 0,
      },
      legend: {
        type: String,
      },
      defaultSort: {
        type: Object as PropType<TSortParams | null>,
        default: null,
      },
    },
  });
